﻿window.cSondage = function (option) {
    var Me = this

    this.jsonQuestion = JSON.parse(option.dataSondage.jsonquestion)
    this.jsonFin = JSON.parse(option.dataSondage.jsonfin)
    this.lstPage = JSON.parse(option.dataSondage.jsonquestion).lst_page
    this.lstPage.push(JSON.parse(option.dataSondage.jsonfin))

    this.dataSondage = option.dataSondage

    this.mSave = function (funcOk) {
        option.dataSondage.jsonquestion = JSON.stringify(this.jsonQuestion)
        option.dataSondage.jsonfin = JSON.stringify(this.jsonFin)
        option.bddCtrl.getObjet(option.dataSondage).mSave(function (data) {
            if (funcOk) funcOk()
        })
    }

    this.mCreateNewPage = function (titre) {
        this.jsonQuestion.last_id_page += 1
        var newPage = {
            titre: titre,
            id_page: this.jsonQuestion.last_id_page,
            lst_question: [],
            last_id_question: 0,
            affiche_titre: true,
            link_img: "",
            position_img: "Aléatoire"
        }
        this.jsonQuestion.lst_page.push(newPage)
        this.mSave()
        return newPage
    }

    this.mDeletePage = function (page) {
        this.jsonQuestion.lst_page.splice(this.jsonQuestion.lst_page.indexOf(page), 1)
        this.mSave()
    }

    this.mDeleteQuestionFromPage = function (page, question) {
        page.lst_question.splice(page.lst_question.indexOf(question), 1)
        this.mSave()
    }

    this.mCreateNewQuestionFromPage = function (page, typeQuestion) {
        page.last_id_question += 1
        var newQuestion = {
            id_page: page.id_page,
            id_question: page.last_id_question,
            type: typeQuestion,
            text_intro: "",
            lst_phrase: [],
            last_id_phrase: 0,
            tx_satisfaction_min: 0,
            tx_satisfaction_max: 100
        }
        page.lst_question.push(newQuestion)
        this.mSave()
        return newQuestion
    }

    this.mGetPageFromQuestion = function (question) {
        return (question.id_page == -1 ? this.jsonFin : this.jsonQuestion.lst_page.filter(function (o) { return o.id_page == question.id_page })[0])
    }

    this.mGetQuestionOuiNonBefore = function (question) {
        var page = this.mGetPageFromQuestion(question)
        if (page) {
            const index = page.lst_question.indexOf(question);
            let trouve = null;

            for (let i = index - 1; i >= 0; i--) {
                const q = page.lst_question[i];
                if (q.type === "ouinon") {
                    trouve = q;
                    break;
                }
            }
            return trouve;
        }
    }

}